import { render, staticRenderFns } from "./modal-add-product-to-bundle.vue?vue&type=template&id=23a209d8&scoped=true&lang=pug"
import script from "./modal-add-product-to-bundle.js?vue&type=script&lang=js&external"
export * from "./modal-add-product-to-bundle.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-product-to-bundle.vue?vue&type=style&index=0&id=23a209d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a209d8",
  null
  
)

export default component.exports